var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-logos"},_vm._l((_vm.sites),function(site,index){return _c('span',{key:index},[(site in _vm.images)?_c('img',{staticStyle:{"width":"100%","max-width":"35px","margin-right":".5rem"},attrs:{"src":_vm.getImageURL(site)}}):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }